import { TagManager } from '@navent-jobs/config'

export const DataLayer = {
  handlerBannerViewTraking: ({ nombreBanner }) => {
    return TagManager.Push({
      event: 'view_promotion',
      creative_name: `Banner principal - ${nombreBanner}`,
      content_group: 'Listado',
    })
  },

  handlerBannerClickTraking: ({ nombreBanner }) => {
    return TagManager.Push({
      event: 'select_promotion',
      creative_name: `Banner principal - ${nombreBanner}`,
      content_group: 'Listado',
    })
  },
}
